import { createAction, props } from '@ngrx/store';
import { MoveDeskDataV26 } from 'src/app/models-v26/move-desk-data-v26';
import { ConsumerTreeNode } from 'src/app/models/consumer';
import { MoveDeskDueDates } from 'src/app/shared-components/allocation-wizard-modal-dialogs/move-wizard/init-step/due-date-step';
import { MoveInitStep } from 'src/app/shared-components/allocation-wizard-modal-dialogs/move-wizard/init-step/move-init-step';

export const selectMoveInitStep = createAction(
  '[V26 User Property Panel] Select Move Init Information Step',
  props<{ initStep: MoveInitStep }>(),
);
export const selectDueDatesStep = createAction(
  '[V26 Move Wizard Due Date Step] Select Move Due Date Step',
  props<{ dueDatesStep: MoveDeskDueDates }>(),
);

export const selectConsumerStep = createAction(
  '[V26 Move Wizard Due Date Step] Select Move Consumer Step',
  props<{ consumerStep: ConsumerTreeNode }>(),
);

export const deleteConsumerStep = createAction('[V26 Move Wizard Consumer Step] Delete Move Consumer Step');

export const exitAllocationMoveWizard = createAction('[V26 Cancel Wizard Page] Exit Allocation Move Wizard');

export const destroyWizard = createAction('[V26 Move Wizard Page] Exit Destroy Wizard');

export const selectFromDeskStep = createAction(
  '[V26 Move Wizard Page] Select Move From Desk Data Step',
  props<{ fromDeskStep: MoveDeskDataV26 }>(),
);
export const selectToDeskStep = createAction(
  '[V26 Move Wizard Page] Select Move To Desk Data Step',
  props<{ toDeskStep: MoveDeskDataV26 }>(),
);

export const sendLicenseServicesMoveRequest = createAction(
  '[V26 Move Wizard Confirmation Step] Create Move Information Step' /*,
  props<{ moveRequest: MoveLicenseServicesRequest }>()*/,
);

export const moveRequestSuccess = createAction(
  '[V26 Move Wizard Confirmation Step] Create Move Information Step Success' /*,
  props<{ response: MoveLicenseServicesResponse }>()*/,
);

export const moveRequestFail = createAction(
  '[V26 Move Wizard Confirmation Step] Create Move Information Step Fail',
  props<{ errorMessage: string }>(),
);
